<template>
  <div>
    <v-form>
      <v-container>
        <span class="headline">{{ $t('create_motor_type_from_excell') }}</span>
        <v-row >
          <v-col v-if="false" cols="12" lg="2" md="3" sm="4">
            <v-select v-model="perf.idpump_type" :items="pumpTypes" label="Type"></v-select>
          </v-col>

          <v-col cols="12" md="9">
            <v-textarea
              v-model="type_data"
              :label="$t('motor_type_datas')"
              :hint="$t('paste_from_excell')"
            ></v-textarea>
          </v-col>

          <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.material" label="Material" required></v-text-field>
          </v-col>-->
        </v-row>

        <div class="my-2">
          <v-col cols="12" md="6">
            <v-btn class="ma-2" @click="parseData" color="primary">{{ $t('save') }}</v-btn>

            <v-btn class="ma-2" @click="goBack" color="secondary">{{ $t('cancel') }}</v-btn>

          </v-col>
           
        </div>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "MotorTypeAddFromExcell",
  data: () => ({
    token: "",
    type_data: "",
    motorType: {
       idmotor_type: -1,
      type: "XSP 20",
      frequency: 50,
      phase: 3,
      voltage : "100-200",
      fi_d_max : 200,
    } ,
    frequency: "",
    motorTypes: []
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
  },
  methods: {
    goBack : function() {
      window.history.go(-1)
    },
    saveMotorTypesData: function() {
      // console.log(this.motorTypes)
      // return

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_motor_type_from_excell?frequency="+this.frequency,
        data: this.motorTypes
      })
        .then(response => {
          console.log(response.data);
          if (response.data == "1"){
           this.motorTypes = ""
           this.motorType.idmotor_type = -1
           if (response.data == "1")
             window.history.go(-1)
          } 
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    parseData: function() {
      // clear datas.
      this.motorType.type = []
      this.motorType.phase = []
      this.motorType.voltage = []
      this.motorType.fi_d_max = []
      this.motorType.frequency = []

      function filterWithStartString(str){
        return str.startsWith("XSM") || str.startsWith("EXSM")
      }

      this.frequency = this.type_data.substring(0,200).replace(/\t/g, "").split(" ")[0]

      var dataLines = this.type_data
        .replace(/\t\t/g, "")
        .replace(/,/g, ".")
        .split("\n");

      dataLines = dataLines.filter(filterWithStartString)

      console.log(dataLines)

      this.motorTypes = []

      dataLines.forEach(line => {
        this.motorTypes.push(
          line.split('\t').map(s => s.trim() )
          )
      })

      console.log(this.motorTypes)
      // console.log(dataLines[5].split('\t'));
 
      this.saveMotorTypesData();
      // console.log(this.perf.hm);
    }
  }
};
</script>
